import { useCallback } from "react";
import { useMutation } from "@apollo/client/react";

import { AcceptInvitationDocument } from "#app/lib/data";

export function useAcceptInvitation() {
  const [runAcceptInvitation, { loading }] = useMutation(
    AcceptInvitationDocument
  );

  const acceptInvitation = useCallback(
    async (workspaceId: string, name: string) => {
      // The invitee has just authenticated and has no workspace selected yet,
      // so Apollo's auth link sends no `workspaceid` header. Force it here so
      // the server can scope DataLoaders for the User type resolvers.
      const result = await runAcceptInvitation({
        variables: { workspaceId, name },
        context: { headers: { workspaceid: workspaceId } },
      });
      return result.data?.acceptInvitation ?? null;
    },
    [runAcceptInvitation]
  );

  return { acceptInvitation, loading };
}
